module.exports = __webpack_public_path__ + "media/whatsapp_iphone.5ba8cd5e.mp3";